/**
 * @author Lorenzo Muscariello <lmuscariello@ciaopeople.com>
 */

/**
 * Used to specify which action should be taken on the playing media after AdBreak completion
 */
export enum ContentResumePolicy {

    RESUME_ALWAYS = "always",
    RESUME_ON_SUCCESS = "on_success",
    NEVER_RESUME = "never"

}